import React,{ Component } from 'react';

import {
  Col,
  Row,
  Container,
  Card
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import Button from '../../../shared/components/Button';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import SearchInput from '../../../shared/components/SearchInput';
import SortableTable from '../../../shared/components/SortableTable';

class RetailerUserList extends Component {
  constructor(props){
    super();

    this.state = {
      filter:'',
      isLoading:false
    };
  }

  componentDidMount(){
    this.setState({isLoading:true});

    this.props.loadAppUsersForRetailer(this.props.retailerId)
      .then(() => this.setState({isLoading:false}))
      .catch(() => this.setState({isLoading:false}));
  }

  handleFilterChange(newFilter){
    this.setState({filter:newFilter});
    this.props.loadFilteredAppUsersForRetailer(newFilter);
  }

  getFilteredAppUsers(){
    const filterText = this.state.filter,
      appUsers = this.props.appUsers;

    return appUsers.filter((u) => u.displayId.indexOf(filterText) >= 0);
  }

  render(){
    const { match,retailerName } = this.props;

    const { filter, isLoading } = this.state;

    return (
      <Container>
        <Row>
          <Col xs='6'>
            <SearchInput
              placeholder={`Search ${retailerName} users by loyalty ID`}
              debounce={500}
              onChange={(val) => this.handleFilterChange(val)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <br />
            <br />
            <Card>
              <SortableTable
                columns={[
                  {name:'Loyalty ID', width:30, sortable:false},
                  {name:'Buffer', width:16, sortable:false},
                  {name:'Card', width:17, sortable:false},
                  {name:'Lifetime', width:17, sortable:false},
                  {name:' ',width:20}
                ]}
                hideHeadersOnEmpty
                emptyText={isLoading ? 'Loading users...' :`No users match "${filter}"`}
              >
                {this.getFilteredAppUsers().map((a) => (
                  <tr key={a.id}>
                    <td>
                      <Link to={`${match.url}/${a.id}`}>
                        {a.displayId}
                      </Link>
                    </td>
                    <td><MoneyDisplay>{a.couponBufferBalance || 0}</MoneyDisplay></td>
                    <td><MoneyDisplay>{a.cardBalance || 0}</MoneyDisplay></td>
                    <td><MoneyDisplay>{a.lifetimeUse || 0}</MoneyDisplay></td>
                    <td>
                      <div className='pull-right'>
                        <Button
                          linkHref={`${match.url}/${a.id}`}
                          textColor='#666666'
                          borderColor='#cccccc'
                          backgroundColor='#ededed'
                        >
                          View
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </SortableTable>
            </Card>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default RetailerUserList;



// WEBPACK FOOTER //
// ./src/routes/RetailerUserList/components/RetailerUserList.js